import React from "react";
import { useParams, useLocation } from "react-router-dom";
import { Helmet } from "react-helmet";
import HighlightsList from "../components/HighlightsList";
import { highlightsData } from "../data/highlightsData";
import { motorRevision911964993 } from "../data/articles/motor-revision-356-911-964-993";
import { motorRevision996to992 } from "../data/articles/motor-instandsetzung-996-997-991-992";
import { getriebeRevision911964993 } from "../data/articles/getriebe-revision-911-964-993";
import { leistungssteigerungen } from "../data/articles/leistungssteigerungen";
import { motorenbauRundumService } from "../data/articles/motorenbauRundumService";
import { porscheReparatur } from "../data/articles/reparatur";
import { restaurationRundumService } from "../data/articles/restaurationRundumService";
import { tuevGutachtenEintragungen } from "../data/articles/tuev";
import { rundumService } from "../data/articles/rundum-service";
import { motorsport } from "../data/articles/motorsport";
import { elektronik } from "../data/articles/elektronik";
import { verkauf } from "../data/articles/verkauf";
import { inspektionWartung } from "../data/articles/inspektion-wartung";
import { restaurationPorsche911 } from "../data/articles/porsche-restauration";
import ArticleComponent from "../components/ArticleComponent";
import ServiceTable from "../components/ServiceTable";

const DetailPage = () => {
  const { slug } = useParams(); // This will contain the dynamic part of the path
  const location = useLocation();
  const { items, icon } = highlightsData[slug] || { items: [], icon: null };

  // Check if we're on the /restauration route
  const isRestaurationRoute = location.pathname === "/restauration";
  // Check if we're on the /motorsport route
  const isMotorsportRoute = location.pathname === "/motorsport";
  // Check if we're on the /service-wartung route
  const isServiceWartungRoute = location.pathname === "/service-wartung";
  // Check if we're on the /porsche-elektronik route
  const isPorscheElektronikRoute = location.pathname === "/porsche-elektronik";
  // Check if we're on the /porsche-reparatur route
  const isPorscheReparaturRoute = location.pathname === "/porsche-reparatur";
  // Check if we're on the /porsche-gutachten route
  const isPorscheGutachtenRoute = location.pathname === "/porsche-gutachten";
  // Check if we're on the /porsche-verkaufen route
  const isPorscheVerkaufenRoute = location.pathname === "/porsche-verkaufen";

  const slugArticleMap = {
    "motor-instandsetzung-996-997-991-992": motorRevision996to992,
    "motor-revision-356-911-964-993": motorRevision911964993,
    "getriebe-revision-911-964-993": getriebeRevision911964993,
    leistungssteigerungen: leistungssteigerungen,
  };

  // Get the appropriate article based on route or slug
  const getArticleData = () => {
    if (isRestaurationRoute) {
      return restaurationPorsche911;
    }
    if (isMotorsportRoute) {
      return motorsport;
    }
    if (isServiceWartungRoute) {
      return inspektionWartung;
    }
    if (isPorscheElektronikRoute) {
      return elektronik;
    }
    if (isPorscheReparaturRoute) {
      return porscheReparatur;
    }
    if (isPorscheGutachtenRoute) {
      return tuevGutachtenEintragungen;
    }
    if (isPorscheVerkaufenRoute) {
      return verkauf;
    }
    return slugArticleMap[slug];
  };

  const articleData = getArticleData();

  // Generate dynamic SEO data based on article content
  const generateSEOData = () => {
    if (!articleData || !articleData.meta) {
      return {
        title: "WTM Sportwagen - Porsche Service",
        description:
          "Professioneller Porsche Service und Reparaturen bei WTM Sportwagen in Gießen.",
        keywords: "Porsche Service, Porsche Reparatur, WTM Sportwagen",
      };
    }

    const { title, description } = articleData.meta;
    const articleTitle = articleData.title || title;

    // Extract keywords from title and description
    const keywords = [
      "Porsche",
      "WTM Sportwagen",
      "Gießen",
      ...(articleTitle?.match(
        /\b(911|964|993|996|997|991|992|Boxster|Cayman|Cayenne|Motor|Getriebe|Service|Wartung|Inspektion|Revision|Restauration|Motorsport|Elektronik)\b/gi
      ) || []),
    ].join(", ");

    return {
      title,
      description,
      keywords,
      articleTitle,
    };
  };

  const seoData = generateSEOData();

  return (
    <>
      <Helmet>
        <title>{seoData.title}</title>
        <meta name="description" content={seoData.description} />
        <meta name="keywords" content={seoData.keywords} />

        {/* Open Graph tags */}
        <meta
          property="og:title"
          content={seoData.articleTitle || seoData.title}
        />
        <meta property="og:description" content={seoData.description} />
        <meta property="og:type" content="article" />
        <meta
          property="og:url"
          content={`https://wtm-sportwagen.com${location.pathname}`}
        />

        {/* Twitter Card */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta
          name="twitter:title"
          content={seoData.articleTitle || seoData.title}
        />
        <meta name="twitter:description" content={seoData.description} />

        {/* Canonical URL */}
        <link
          rel="canonical"
          href={`https://wtm-sportwagen.com${location.pathname}`}
        />

        {/* Article specific meta */}
        <meta name="article:author" content="WTM Sportwagen" />
        <meta name="article:publisher" content="WTM Sportwagen" />
      </Helmet>

      <div style={{ backgroundColor: "var(--color-primary)" }}>
        <ArticleComponent
          {...articleData}
          showTitle={true}
          showHeader={false}
          isFirstArticle={true}
        />

        {/* {slug === "leistungssteigerungen" && <ArticleComponent {...motorenbauRundumService} showTitle={true} showHeader={false}/>} */}
        {/* {slug === "motor-revision-356-911-964-993" ||
        slug === "getriebe-revision-911-964-993" ||
        (slug === "motor-instandsetzung-996-997-991-992" && (
          <ArticleComponent
            {...rundumService}
            showTitle={true}
            showHeader={false}
          />
        ))} */}
        {/* {isRestaurationRoute && (
        <ArticleComponent
          {...restaurationRundumService}
          showTitle={true}
          showHeader={false}
        />
      )} */}
      </div>
    </>
  );
};

export default DetailPage;
